// Empty string -> relative paths, i.e. same-origin (production, reverse-proxied
// through the site's own domain). Local dev overrides this via .env, since the
// dev frontend (localhost:3000) and API (localhost:4000) run on different ports.
const API_URL = process.env.REACT_APP_API_URL || '';

async function handle(res) {
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Request failed with status ${res.status}`);
    }
    if (res.status === 204) return null;
    return res.json();
}

export async function getComments(pageKey) {
    const res = await fetch(`${API_URL}/api/comments?page=${encodeURIComponent(pageKey)}`, {
        credentials: 'include',
    });
    return handle(res);
}

export async function postComment({pageKey, body, authorName}) {
    const res = await fetch(`${API_URL}/api/comments`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({pageKey, body, authorName}),
    });
    return handle(res);
}

export async function deleteComment(id) {
    const res = await fetch(`${API_URL}/api/comments/${id}`, {
        method: 'DELETE',
        credentials: 'include',
    });
    return handle(res);
}
